import { getFormBudgetCorrectRecordList, getFormBudgetList } from '../services';

export default {
  namespace: 'formBudgetQuery',
  state: {},
  effects: {
    // 部门单据预算明细查询
    *getFormBudgetList({ payload }, { call }) {
      return yield call(getFormBudgetList, payload);
    },

    // 预算订正历史查询
    *getFormBudgetCorrectRecordList({ payload }, { call }) {
      return yield call(getFormBudgetCorrectRecordList, payload);
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
